
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { CompanyModel } from './Entities.GormCrm.Company';
import { Model, ModelProperty } from 'models/Model';


export class CompanyExternalKeyModel extends Model<CompanyExternalKeyModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'companyId', type: 'string' },
		{ name: 'key', type: 'string' },
		{ name: 'type', type: 'number' },
		{ name: 'company', type: 'CompanyModel', isHidden: true, isObject: true, new: () => { return new CompanyModel }, properties: () => { return CompanyModel.classProperties } }
	];
	[key: string]: any;
	
	public companyId?: string;
	public key: string;
	public type: number;
	public company?: CompanyModel;
    
	constructor(){
		super();
		this.companyId = undefined;
		this.key = '';
		this.type = 0;
		this.company = undefined;
		
	}
	getProperties(){
		return CompanyExternalKeyModel.classProperties;
	}
}

